var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('basic-card',{staticClass:"mt-9",attrs:{"title":"$l.api.subjects.apiSubjectCard"}},[_c('SubjectCard',{attrs:{"card-id":_vm.$route.params.cardId,"full-page":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }